import { DONATION_ROUTES, ROUTES } from '@/constants/routes';

const CS_CHAT_SECTIONS = [ROUTES.MY.pathname, DONATION_ROUTES.MY.pathname];

export const isCsChatPath = (pathname: string | null) =>
  CS_CHAT_SECTIONS.some(
    (section) => pathname === section || !!pathname?.startsWith(`${section}/`),
  );
